import { combineReducers } from 'redux'
import detail from './detail.reducer'
import fund from './fund.reducer'

export default combineReducers({
  detail,
  fundDetail: fund
})
